import { AutogenLayoutMovementUsers } from "./autogen/AutogenLayoutMovementUsers";

export class MovementUsers extends AutogenLayoutMovementUsers {
    override onLoad() {
        const LME_USER_FILTER = event => { event.filter.web_user_type = "U" };
        this.textboxDispatcherUserId.addBeforeLookupModelSearchListener(LME_USER_FILTER);
        this.textboxOperationsUser.addBeforeLookupModelSearchListener(LME_USER_FILTER);
    }
}
